import { trackEvent } from 'analytics/analytics'
import { searchResultsEventWithContext } from 'analytics/snowplow/events'
import type {
  Filter_1_0_0,
  SearchContext_1_0_3,
  Sort_1_0_0,
} from '@luxuryescapes/contract-data-event-schemas/lib/com.luxgroup'

export interface SearchResultsTrackingOptions {
  searchContext: SearchContext_1_0_3
  filterContexts?: Array<Filter_1_0_0>
  sortContext?: Sort_1_0_0
  searchSessionId?: string
}

export function trackSearchResultsEvent(
  tracking: SearchResultsTrackingOptions,
  numberOfResults: number,
): void {
  trackEvent(searchResultsEventWithContext({
    numberOfResults,
    searchContext: tracking.searchContext,
    filterContexts: tracking.filterContexts,
    sortContext: tracking.sortContext ?? { value: 'recommended' },
    searchSessionId: tracking.searchSessionId,
  }))
}
